module.exports = __webpack_public_path__ + "img/巡检记录.1cc52939.png";